

import React from 'react';
import {  Form, Input, message, Modal, Radio, Spin } from 'antd';

import { fetchRentContractApplyApproval } from '../../../../services/rentContractApply';
/**
 * 分账记录 - 流程审批
 */
class RentContractApproval extends React.Component{
    constructor() {
        super();
        this.state = {
            visible: false,
            loading: false,
            formData: {},
        };
    }

  
    open = (id) => {
        this.id = id
        this.setState({ visible: true });
        return new Promise((resolve, reject) => {
            this.monitor = { resolve, reject }
        })
    };

    close = () => {
        this.setState({ visible: false, formData: {} });
    };


    checkFormData = (data) => {
        if (!data.status) return message.warn('请选择状态')
        if (data.status === 2 && !data.remarks) return message.warn('请输入备注')
        return true
    }

    handleChange = (e,key) => {
        const { value } = e.target
        this.setState(state => {
            state.formData[key] = value
            if (key === 'status') {
                state.formData.remarks = ''
            }
            return state
        })
    }
 



    handleOk = () => {
        if (this.checkFormData(this.state.formData) !== true) return
        this.postConfirmationProcess().then(() => {
            this.close()
            this.monitor.resolve()
        })
    }

 
    postConfirmationProcess() {
        const data = {
            ...this.state.formData,
            id: this.id
        }
      
        this.setState({ loading: true })
        return fetchRentContractApplyApproval(data).then(() => {
            message.success('操作成功')
        }).finally(()=>{
            this.setState({ loading: false })
        })
    }
    render(){
        const loading = !!this.state.loading
        return (
           <Modal title="合同审批" visible={this.state.visible} onOk={this.handleOk} onCancel={this.close} confirmLoading={loading}>
               <Spin spinning={loading}>
                    <Form style={{padding: 20}} >
                        <Form.Item required label="审核" style={{marginBottom: 5}}>
                            <Radio.Group onChange={(e) => this.handleChange(e, 'status')} value={this.state.formData.status}>
                                <Radio value={1}>通过</Radio>
                                <Radio value={2}>不通过</Radio>
                            </Radio.Group>
                        </Form.Item>
                        
                        <Form.Item required label="备注">
                            <Input.TextArea disabled={this.state.formData.status === 1} onChange={(e) => this.handleChange(e, 'remarks')} value={this.state.formData.remarks}  />
                        </Form.Item>
                        
                    </Form>
                </Spin>
           </Modal>
           
        )
    }

}

export default RentContractApproval


// WEBPACK FOOTER //
// ./src/page/RentContract/components/ContractApproval/index.jsx